<template>
  <ul
    v-if="isHomeVersionDefault"
    class="type-toggle nav nav-fill nav-pills"
    id="pills-tab"
    role="tablist"
  >
    <v-sheet
      class="mx-auto slider-width"
      max-width="100%"
      width="100%"
      style="background: none"
    >
      <v-slide-group
        show-arrows="mobile"
        class="menu-center align-items-center"
        mandatory
      >
        <template v-for="(menu, index) in sortedMenuList">
          <v-slide-item
            :key="`food${index}`"
            class="px-2"
            v-slot:default="{ active }"
            v-if="
              menu !== undefined &&
                menu.type === 'principal' &&
                menu.id === productTypeIds.food &&
                !disableAddFood &&
                displayComidas() &&
                validFood
            "
          >
            <v-btn
              class="mb-2 slider-btn"
              :input-value="active"
              depressed
              rounded
              :ripple="false"
              :class="'active'"
              :color="colorsFoodPrimary"
              @click="
                onTab(productTypeIds.food);
                selectColor({
                  primaryColor: colorsFoodPrimary,
                  secondaryColor: colorsFoodSecondary
                });
              "
            >
              {{ $t("common.food") }}
            </v-btn>
          </v-slide-item>
          <v-slide-item
            :key="`drinks${index}`"
            class="px-2"
            v-slot:default="{ active, toggle }"
            v-if="
              menu !== undefined &&
                menu.type === 'principal' &&
                menu.id === productTypeIds.drinks &&
                !disableAddDrinks &&
                displayBebidas() &&
                validDrinks
            "
          >
            <v-btn
              class="mb-2 slider-btn"
              depressed
              rounded
              :input-value="active"
              :ripple="false"
              :class="'active'"
              :color="colorsDrinksPrimary"
              @click="
                onTab(productTypeIds.drinks);
                toggle;
                selectColor({
                  primaryColor: colorsDrinksPrimary,
                  secondaryColor: colorsDrinksSecondary
                });
              "
            >
              {{ $t("common.drinks") }}
            </v-btn>
          </v-slide-item>
          <v-slide-item
            :key="`dessert${index}`"
            class="px-2"
            v-slot:default="{ active, toggle }"
            v-if="
              menu !== undefined &&
                menu.type === 'principal' &&
                menu.id === productTypeIds.dessert &&
                !disableAddDessert &&
                displayPostres() &&
                validDessert
            "
          >
            <v-btn
              class="mb-2 slider-btn"
              depressed
              rounded
              :input-value="active"
              :ripple="false"
              :class="'active'"
              :color="colorsDessertPrimary"
              @click="
                onTab(productTypeIds.dessert);
                toggle;
                selectColor({
                  primaryColor: colorsDessertPrimary,
                  secondaryColor: colorsDessertSecondary
                });
              "
            >
              {{ $t("common.dessert") }}
            </v-btn>
          </v-slide-item>
          <v-slide-item
            v-if="
              menu !== undefined &&
                menu.type === 'menus' &&
                displayMenu(menu) &&
                !disableMenuBySchedule(menu) &&
                validMenuProducts(menu)
            "
            :key="index"
            v-slot:default="{ active, toggle }"
            class="px-2"
          >
            <v-btn
              :input-value="active"
              :key="`menu_${index}`"
              :ripple="false"
              class="mb-2 slider-btn"
              :color="menu.primaryColor ? menu.primaryColor : '#000000'"
              depressed
              rounded
              @click="
                onTab(menu.id);
                toggle;
                selectColor(menu);
              "
            >
              {{ translate("name", menu) }}
            </v-btn>
          </v-slide-item>
          <v-slide-item
            :key="`menu_group${index}`"
            v-if="
              menu !== undefined &&
                menu.type === 'menu_group' &&
                displayMenu(menu) &&
                !disableMenuGroup(menu) &&
                validMenuGroupProducts(menu)
            "
            v-slot="{ active, toggle }"
            class="px-2"
            v-touch="{
              left: () => $emit('childSwipe', { direction: 'Left', index: 0 }),
              right: () =>
                $emit('childSwipe', { direction: 'Right', index: 0 }),
              up: () => $emit('childSwipe', { direction: 'Up', index: 0 }),
              down: () => $emit('childSwipe', { direction: 'Down', index: 0 })
            }"
          >
            <v-btn
              :input-value="active"
              :key="`menu_group_${index}`"
              :ripple="false"
              class="mb-2 slider-btn"
              depressed
              rounded
              :color="menu.primaryColor ? menu.primaryColor : '#000000'"
              @click="
                onMenuGroupTab(menu.id);
                toggle;
                selectColor(menu);
              "
            >
              {{ translate("name", menu) }}
            </v-btn>
          </v-slide-item>
        </template>
      </v-slide-group>
    </v-sheet>
  </ul>
</template>

<script>
export default {
  name: "DefaultSlider",
  props: [
    "menus",
    "menuGroup",
    "scheduleByMenu",
    "scheduleByMenuGroup",
    "disableAddFood",
    "disableAddDrinks",
    "disableAddDessert",
    "food",
    "drinks",
    "dessert",
    "sortedMenuList",
    "validFood",
    "validDrinks",
    "validDessert"
  ],
  methods: {
    disableMenuBySchedule(menu) {
      let menuSchedule = this.scheduleByMenu.find(x => x.menuId === menu.id);
      return menuSchedule ? this.disableMenu(menuSchedule.schedule) : false;
    },
    disableMenuGroup(menu) {
      let menuSchedule = this.scheduleByMenuGroup.find(
        x => x.menuId === menu.id
      );
      return menuSchedule ? this.disableMenu(menuSchedule.schedule) : false;
    },
    onTab(Id) {
      this.$emit("onTab", Id);
    },
    selectColor(menu) {
      this.$emit("setColor", menu);
    },
    onCategoryTab(categoryId) {
      this.$emit("onCategoryTab", categoryId);
    },
    onMenuGroupTab(menuGroupId) {
      this.$emit("onMenuGroupTab", menuGroupId);
    }
  }
};
</script>

<style scoped lang="scss"></style>
